import { keaPalette } from '../../styles/designTokens';

export default {
  palette: {
    primary: {
      main: keaPalette.primary,
      lighter: keaPalette.primarySoft,
      light: keaPalette.primaryBorder,
      dark: keaPalette.primaryHover,
      darker: keaPalette.primaryActive,
      contrastText: keaPalette.onPrimary,
    },
    secondary: {
      main: '#1F2349',
      lighter: '#D8DAEF',
      light: '#8E92C7',
      dark: '#161A3A',
      darker: '#0D1026',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#BF0711',
      lighter: '#FF808B',
      light: '#FFBABA',
      dark: '#9D0416',
      darker: '#80020D',
    },
    warning: {
      main: '#FFC453',
      lighter: '#FFEB99',
      light: '#FFE066',
      dark: '#D39A00',
      darker: '#BF7B00',
    },
    info: {
      main: '#1F2349',
      lighter: '#D8DAEF',
      light: '#8E92C7',
      dark: '#161A3A',
      darker: '#0D1026',
    },
    success: {
      main: '#008C73',
      lighter: '#ABE1D9',
      light: '#66D4C4',
      dark: '#006854',
      darker: '#004837',
    },
  },
  status: {
    danger: 'orange',
  },
  typography: {
    button: {
      fontWeight: 400,
      textAlign: 'capitalize',
    },
  },
};
